import Vue from 'vue';
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);
import {validationMixin} from 'vuelidate';
import {required, minLength, maxLength} from 'vuelidate/lib/validators';

import {mapActions, mapGetters, mapMutations} from "vuex";

import {
    FAVORITES_UPDATE_NAME_LIST
} from "@/store/action-types";

import {
    FAVORITES_SHOW_POPUP_EDIT_NAME_LIST,
    SET_EDITED_NAME_DATA
} from '@/store/mutation-types'

export default {
    name: 'favorites-edit-name',
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                name: '',
                id: ''
            },
            validationErrors: {
                name: []
            }
        }
    },
    validations: {
        payload: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(15),
            },
        }
    },
    watch: {
        'payload.name'() {
            let error = [];

            if (!this.$v.payload.name.required) {
                error.push(this.$t('fieldRequired').replace(':name', this.$t('name')))
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t('validationMin').replace(':count', 3));
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t('validationMax').replace(':count', 15));
            }

            this.validationErrors.name = error;
        },
    },
    mounted(){
        //set default name
        this.payload.name = this.editedNameData.name;
        this.payload.id = this.editedNameData.id;
        // end
    },
    computed: {
        ...mapGetters({
            updateNameLoading: 'favorites/updateNameLoading',
            editedNameData: 'favorites/editedNameData',
        }),
        disableButton(){
            if(this.editedNameData.name === this.payload.name){
                return true
            }else{
                return this.$v.$invalid;
            }
        },
        errorsMessages() {
            let errors = [];
            for (let i  in this.validationErrors) {
                this.validationErrors[i].forEach(e => {
                    errors.push(e);
                })
            }
            return errors;
        },
    },
    methods: {
        ...mapActions({
            renameList: `favorites/${FAVORITES_UPDATE_NAME_LIST}`
        }),
        ...mapMutations({
            changeShowPopupRenameList: `favorites/${FAVORITES_SHOW_POPUP_EDIT_NAME_LIST}`,
            setEditedData: `favorites/${SET_EDITED_NAME_DATA}`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.renameList(this.payload)
                    .then(() => {
                        this.changeShowPopupRenameList(false);
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            for (let field in error.response.data.errors) {
                                this.validationErrors[field] = error.response.data.errors[field];
                            }
                        }
                    });


            }
        }
    },
    destroyed() {

    }
}
